<template>
  <div>
    <div class="color-red font-16 mb-10">
      <i class="el-icon-warning mr-5" />
      <span>存在部分渠道号未成功匹配渠道包，请检查</span>
    </div>
    <app-table
      ref="app-table"
      :is-current-page="false"
      :page-size="2000"
      :table-props="{ 'max-height': '450px' }"
      :table-key="table_key"
      :table-list-data="tableData"
    />
    <el-dialog
      v-if="dialog_config.is_show"
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      append-to-body
      width="800px"
    >
      <channel-package
        v-if="dialog_config.is_show"
        v-bind="dialog_config.props"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
  </div>
</template>

<script>
import { getChannelPackageApi, pullChannelPackageApi } from '@/api/tool/channel-package';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'channel-package': () => import('@/views/fusion/investment/intelligence-create/components/main-view/components/preview-table/components/channel-package/index.vue'),
  },
  props: {
    // 页面配置
    pageConfig: {
      type: Object,
      required: true,
    },
    // 表格数据
    tableData: {
      type: Array,
      required: true,
    },
    // 请求参数
    params: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      // 表头配置
      table_key: require('./model/table-key.js')(this),
      // 弹窗配置
      dialog_config: {
        is_show: false,
        title: '应用渠道包',
        props: {
          tableParams: this.getChannelPackageFiltering(),
          getList: this.getChannelPackageList,
          pullParams: this.getPullChannelPackageParams(),
          pullApi: pullChannelPackageApi,
        },
        confirm: () => {},
      },
    };
  },
  methods: {
    /**
     * 选择渠道包
     * @param {Object} row 当前行数据
     * @returns {void}
     */
    onOpen(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        confirm: (data) => {
          Object.assign(row, {
            channel_package_id: data.id,
            channel_package_name: data.name,
          });
          this.dialog_config.is_show = false;
        },
      });
    },
    /**
     * 获取查询应用渠道包查询参数
     * @returns {Object}
     */
    getChannelPackageFiltering() {
      const { channel_interface } = this.pageConfig;
      const { advertiser_id, delivery_content_id } = this.params;
      return {
        channel_interface,
        advertiser_id,
        page: 1,
        page_size: 10,
        filtering: {
          delivery_content_id,
        },
      };
    },
    /**
     * 获取渠道包列表
     * @param {Object} params 查询参数
     * @returns {Promise<Object>}
     */
    getChannelPackageList(params) {
      return new Promise((resolve, reject) => {
        getChannelPackageApi(params)
          .then((res) => {
            res.list.forEach((item) => {
              Object.assign(item, { template_data: JSON.stringify(item) });
            });
            resolve(res);
          })
          .catch(reject);
      });
    },
    /**
     * 获取同步应用渠道包请求参数
     * @returns {Object}
     */
    getPullChannelPackageParams() {
      const { channel_interface } = this.pageConfig;
      const { advertiser_id, delivery_content_id } = this.params;
      return {
        channel_interface,
        advertiser_id,
        filtering: {
          delivery_content_id,
        },
      };
    },
  },
};
</script>
